import { render, staticRenderFns } from "./BackofficeProcedimentoAutorizarQuantidade.vue?vue&type=template&id=5f47a2d3"
import script from "./BackofficeProcedimentoAutorizarQuantidade.vue?vue&type=script&lang=ts"
export * from "./BackofficeProcedimentoAutorizarQuantidade.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeProcedimentoAutorizarQuantidade.vue?vue&type=style&index=0&id=5f47a2d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports